module.exports = __webpack_public_path__ + "180e2095.svg";